import { useEffect, useState } from "react";
import { db } from "../../../../../globals/firebase";
import { w2popup } from 'https://cdn.jsdelivr.net/gh/vitmalina/w2ui@master/dist/w2ui.es6.min.js'
import { doc, updateDoc, getDoc, where, onSnapshot } from "firebase/firestore";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import CheckoutForm from "../checkoutform";
import { Modal } from 'react-responsive-modal';
import { useTranslation } from "react-i18next";



function SectionJobsPayment() {
    const { t } = useTranslation();
    const [usercreditsimages, setusercreditsimages] = useState(0);
    const [user, setuser] = useState(null);
    const [modalOpencheckout, setmodalOpencheckout] = useState("");


    const [dataprice, setdataprice] = useState({
        pricei: 0,
        pricep: 1.99,
        images: 0,
        prompts: 100
    });

    const marksp = {
        0: "0",
        10: "100",
        30: '300',
        50: '500',
        100: '1000'
    };

    const marksi = {
        0: "0",
        10: "100",
        30: '300',
        50: '500',
        100: '1000'
    };



    useEffect(() => {

        const userData = localStorage.getItem("user");
        if (userData) {
            setuser(JSON.parse(userData));
        } else {
            console.warn("User not found in localStorage");
        }


    }, [])

    const setpaymentp = async (value) => {
        switch (value) {
            case 0:
                setdataprice({
                    pricep: 0,
                    prompts: 0,
                    pricei: dataprice.pricei,
                    images: dataprice.images

                })
                break
            case 10:
                setdataprice({
                    pricep: 1.99,
                    prompts: 100,
                    pricei: dataprice.pricei,
                    images: dataprice.images

                })
                break
            case 30:
                setdataprice({
                    pricep: 4.99,
                    prompts: 300,
                    pricei: dataprice.pricei,
                    images: dataprice.images
                })
                break
            case 50:
                setdataprice({
                    pricep: 9.99,
                    prompts: 500,
                    pricei: dataprice.pricei,
                    images: dataprice.images
                })
                break
            case 100:
                setdataprice({
                    pricep: 14.99,
                    prompts: 1000,
                    pricei: dataprice.pricei,
                    images: dataprice.images
                })
                break
            default:
                console.log("erro")
                break

        }




    }



    const setpaymenti = async (value) => {
        switch (value) {
            case 0:
                setdataprice({
                    pricei: 0,
                    images: 0,
                    prompts: dataprice.prompts,
                    pricep: dataprice.pricep
                })
                break
            case 10:
                setdataprice({
                    pricei: 1.99,
                    images: 100,
                    prompts: dataprice.prompts,
                    pricep: dataprice.pricep
                })
                break
            case 30:
                setdataprice({
                    pricei: 4.99,
                    images: 300,
                    prompts: dataprice.prompts,
                    pricep: dataprice.pricep
                })
                break
            case 50:
                setdataprice({
                    pricei: 9.99,
                    images: 500,
                    prompts: dataprice.prompts,
                    pricep: dataprice.pricep
                })
                break
            case 100:
                setdataprice({
                    pricei: 14.99,
                    images: 1000,
                    prompts: dataprice.prompts,
                    pricep: dataprice.pricep
                })
                break
            default:
                console.log("err")
                break
        }



    }




    const setcreditsimages = async (credits) => {

        const userData = localStorage.getItem("user");
        if (!userData) {
            console.warn("User not found in localStorage");
            return;
        }
        
        const user = JSON.parse(userData);
        if (!user.userid) {
            console.warn("User ID not found in user data");
            return;
        }

        const userid = user.userid;
        const docRef = doc(db, "wpm_users", userid)
        await updateDoc(docRef, {
            creditsimages: usercreditsimages + credits
        });

        setusercreditsimages(usercreditsimages + credits)
    }

    const notify = (type, wait, message) => {
        if (wait === false) {
            let color = ""

            if (type === 'error') {
                w2popup.close()
                color = 'red'
            }

            if (type == 'success') {
                color = 'green'
            }

            if (type === 'message') {
                color = 'gold'
            }

            const titlet = type === "error" ? "Error" : ""
            const title = '<span style="color:' + color + ';font-weight:bold">' + titlet + '</span'
            const messagebody = '<span style="color:' + color + '">' + message + '</span'

            w2popup.open({
                modal: true,
                width: 250,       // width of the popup
                height: 150,       // height of the popup
                color: '#000',
                title: title,
                body: messagebody,
                showClose: true,
                actions: {
                    Ok(event) {
                        w2popup.close()
                    }
                }
            })


        }

        if (wait === true) {
            w2popup.open({
                modal: true,
                width: 250,       // width of the popup
                height: 150,       // height of the popup
                color: '#000',
                text: t('general.pleasewait'),
                showClose: false,

            })


        }
    }

    const closenotify = () => {
        w2popup.close()
    }



    return (
        <>

            <Modal
                center
                open={modalOpencheckout}
                onClose={() => setmodalOpencheckout(false)}
                styles = {{width:"50%"}}
                >
                <div>
                    <CheckoutForm dataprice={dataprice} />
                </div>
            </Modal>


            <div className="container">
                <div className="row">

                    <div style={{ width: "100%" }}>

                        <div>
                            <ul>
                                <li>
                                    {t('payment.getcredits')}
                                </li>
                                <li>
                                    {t('payment.createprivate')}
                                </li>

                            </ul>


                            <p>
                                {t('payment.purchaseinfo')}
                            </p>


                        </div>

                        <div style={{ width: '100%', fontWeight: "bold" }}>
                            <div style={{ width: '100%', fontWeight: "bold" }}> {t('payment.promptscredits')}</div>
                            <Slider dots min={0} marks={marksp} step={null} onChange={(e) => { setpaymentp(parseInt(e)) }} defaultValue={10} />
                        </div>

                        <div style={{ height: '30px' }}></div>

                        <div style={{ width: '100%', fontWeight: "bold" }}>
                            <div style={{ width: '100%', fontWeight: "bold" }}> {t('payment.imagescredits')}</div>
                            <Slider dots min={0} marks={marksi} step={null} onChange={(e) => { setpaymenti(parseInt(e)) }} defaultValue={0} />
                        </div>

                        <div className="section-content">
                            <div className="twm-tabs-style-1">
                                <div className="tab-content" id="myTab3Content">
                                    <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="Monthly">



                                        {/* <PayPalScriptProvider options={initialOptions}>
                                            <Checkout price={dataprice} />
                                        </PayPalScriptProvider> */}
                                        {/* <CheckoutProvider stripe={stripepromisse} options={{ fetchClientSecret }}>
                                            <CheckoutForm />
                                        </CheckoutProvider> */}

                                        {(dataprice.pricei + dataprice.pricep) > 0 ?
                                            <div style={{paddingTop:"30px"}}>

                                                <button style={{ fontSize: "15px" }} type="submit" className="site-button"
                                                    onClick={(e) => { e.preventDefault(); setmodalOpencheckout(true) }}>
                                                        {t('payment.paywithstripe')} ${(dataprice.pricei + dataprice.pricep).toFixed(2)}
                                                </button>

                                            </div>
                                            : ""}

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div >

            </div>

        </>
    )
}

export default SectionJobsPayment;